"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signupSagas = void 0;
var effects_1 = require("redux-saga/effects");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var LoginAction_1 = require("@/pages/common/actions/LoginAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var LoginState_1 = require("@/pages/common/states/LoginState");
var SfavAction_1 = require("@/pages/search/actions/sfilter/SfavAction");
var SignupApiSaga_1 = require("@/pages/search/sagas/api/SignupApiSaga");
var ExistingLoginAction_1 = require("@/pages/search/actions/sfilter/ExistingLoginAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var Pages_1 = require("@/rendering/common/Pages");
var EnquireSagaCall_1 = require("@/pages/search/sagas/EnquireSagaCall");
var isSignupPanelActive = function (state) {
    return state.signup.isActive && state.signup.isDim;
};
var watchSignupCloseClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SignupAction_1.default.ON_SIGNUP_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.togglePanelActive())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSignupLoginClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(SignupAction_1.default.ON_SIGNUP_LOGIN_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.togglePanelActive())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.togglePanelActive())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchSignupTogglePanelActive = function () {
    var isActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(SignupAction_1.default.TOGGLE_SINGUP_PANEL_ACTIVE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(isSignupPanelActive)];
            case 2:
                isActive = _a.sent();
                if (!isActive) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelDim(false))];
            case 5:
                _a.sent();
                return [3 /*break*/, 11];
            case 6: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState(''))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelDim(true))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelActive(true))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var handleSignupResponse = function (response, slient) {
    var signupResponse, _a, email, id, firstname, lastname, phone;
    if (slient === void 0) { slient = false; }
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!!response) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiCallError'))];
            case 1:
                _b.sent();
                return [2 /*return*/, false];
            case 2:
                signupResponse = response.data;
                if (!signupResponse.result.hasError) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setGlobalError(response.data.result.message))];
            case 3:
                _b.sent();
                return [2 /*return*/, false];
            case 4:
                _a = {
                    email: signupResponse.user.email,
                    id: signupResponse.user.userId,
                    firstname: signupResponse.user.firstName,
                    lastname: signupResponse.user.lastName,
                    phone: signupResponse.user.phone,
                }, email = _a.email, id = _a.id, firstname = _a.firstname, lastname = _a.lastname, phone = _a.phone;
                return [4 /*yield*/, effects_1.put(UserAction_1.default.setUser({
                        id: id,
                        email: email,
                        firstname: firstname,
                        lastname: lastname,
                        phone: phone,
                        salutation: LoginState_1.Salutation.NONE,
                        subscribed: false,
                        from: '',
                        isConfirmed: false,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfavAction_1.default.setSaveSearchFromRemote())];
            case 6:
                _b.sent();
                if (!!slient) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('signup_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'signupSuccess'))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.resumeState())];
            case 9:
                _b.sent();
                return [2 /*return*/, true];
        }
    });
};
var watchSignupSubmit = function () {
    var payload, fields, response, silent, accountCreateSuccess, signupRespone, state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(SignupAction_1.default.ON_SIGNUP_SUBMIT)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setLoading(true))];
            case 2:
                _a.sent();
                fields = payload;
                return [4 /*yield*/, effects_1.call(SignupApiSaga_1.signupApi, fields)];
            case 3:
                response = _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setLoading(false))];
            case 4:
                _a.sent();
                silent = false;
                return [4 /*yield*/, effects_1.delay(100)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(handleSignupResponse, response, silent)];
            case 6:
                accountCreateSuccess = _a.sent();
                if (!!accountCreateSuccess) return [3 /*break*/, 13];
                signupRespone = response.data;
                return [4 /*yield*/, effects_1.select()];
            case 7:
                state = _a.sent();
                if (!(state.page === Pages_1.Pages.SEARCH)) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveSearchSetToLocalStorage, fields.email)];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setLoginProvider(signupRespone.user.loginProvider))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setEmail(signupRespone.user.email))];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.show())];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var signupSagas = {
    watchSignupCloseClick: watchSignupCloseClick,
    watchSignupLoginClick: watchSignupLoginClick,
    watchSignupTogglePanelActive: watchSignupTogglePanelActive,
    watchSignupSubmit: watchSignupSubmit,
};
exports.signupSagas = signupSagas;
